import Vue from "vue";
import VueI18n from "vue-i18n";
import zhCN from 'vxe-table/lib/locale/lang/zh-CN'
import enUS from 'vxe-table/lib/locale/lang/en-US'
import { VxeUI } from 'vxe-table'
import cn from "./lang/cn";
import ja from "./lang/ja";
import en from "./lang/en";

Vue.use(VueI18n);

// 整合 VxeTable 的语言包
const messages = {
  cn: {
    ...cn,
    ...zhCN // 将 VxeTable 中文包合并到 cn 语言
  },
  en: {
    ...en,
    ...enUS // 将 VxeTable 英文包合并到 en 语言
  },
  ja: {
    ...ja
  }
};

const i18n = new VueI18n({
  locale: localStorage.getItem("lang") ? localStorage.getItem("lang") : "en",
  messages
});

// 配置vxe-table的i18n
VxeUI.setI18n('en', enUS)
VxeUI.setI18n('zh', zhCN)

// 配置 VxeUI 的自定义 i18n 函数
VxeUI.setConfig({
  i18n: (key) => {
    const lang = localStorage.getItem('lang') === 'en' ? 'en' : 'zh'
    
    // 辅助函数：根据点分隔的key路径获取嵌套对象的值
    const getNestedValue = (obj, path) => {
      return path.split('.').reduce((current, prop) => {
        return current && current[prop] !== undefined ? current[prop] : undefined
      }, obj)
    }
    
    const customZhCN = {
      'vxe.custom.setting.colVisible':'是否显示',
      'vxe.custom.setting.sortHelpTip':'点击并拖动调整顺序',
      'vxe.toolbar.custom':'列设置',
      'vxe.toolbar.fixedRight': '固定右侧',
      'vxe.toolbar.cancelFixed':'取消固定',
      'vxe.toolbar.fixedLeft': '固定左侧',
    }
    const customEnUS = {
      'vxe.custom.setting.colVisible':'Whether to display',
      'vxe.custom.setting.sortHelpTip':'Click and drag the icons to adjust the order.',
      'vxe.toolbar.custom':'Column settings',
      'vxe.toolbar.fixedRight': 'Fixed Right',
      'vxe.toolbar.cancelFixed':'Unfixed',
      'vxe.toolbar.fixedLeft': 'Fixed Left',
    }
    
    if (lang === 'en') {
      return customEnUS[key] || getNestedValue(enUS, key) || key
    } else {
      return customZhCN[key] || getNestedValue(zhCN, key) || key
    }
  }
})

// 监听语言变化，同步更新vxe-table的语言
i18n._vm.$watch('locale', (val) => {
  // 确保语言标识符正确映射
  const vxeLang = val === 'en' ? 'en' : 'zh'
  console.log('Setting VxeUI language to:', vxeLang)
  VxeUI.setLanguage(vxeLang)
})

// 初始化时也设置一次
const currentLang = localStorage.getItem("lang") || "en"
const vxeLang = currentLang === 'en' ? 'en' : 'zh'
VxeUI.setLanguage(vxeLang)

export default i18n;